module.exports = __webpack_public_path__ + "static/img/login_new_left.e5ec1869.png";